function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import Cookies from "js-cookie";
import { ACCESS_TOKEN_COOKIE_NAME } from "./constants";
import jwtDecode from "jwt-decode";
var getUserId = function() {
    var _accessToken;
    var encodedAccessToken = Cookies.get(ACCESS_TOKEN_COOKIE_NAME);
    var accessToken = jwtDecode(encodedAccessToken);
    return (_accessToken = accessToken) == null ? void 0 : _accessToken.uid;
};
var encodeObject = function(object) {
    var uid = getUserId();
    if (!object || !uid) return;
    var jsonString = JSON.stringify(_extends({}, object, {
        uid: uid
    }));
    return btoa(jsonString);
};
var decodeObject = function(base64String) {
    var _object;
    var uid = getUserId();
    if (!base64String || !uid) return;
    // Note: atob(null) returns "\u009eée" which causes JSON.parse() to fail
    var jsonString = atob(base64String);
    var object = JSON.parse(jsonString);
    if (((_object = object) == null ? void 0 : _object.uid) === uid) return object;
};
export { encodeObject, decodeObject };
